import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppContext from "../../context/app/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";

import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";

import PrizeContextProvider from "../../context/prize/provider";
import StoreJoinRequestTable from "../../components/store-join-request/store-join-request-table";
import StoreJoinRequestContextProvider from "../../context/store-join-request/provider";
import StoreJoinRequestContext from "../../context/store-join-request/context";
interface IProps {
  children?: React.ReactNode;
}

// sum array in js
const Store: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);

  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(StoreJoinRequestContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);
  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("stores-join-requests")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,

          <Divider key={1} type="vertical" />,

 
        ]}
      />
      <StoreJoinRequestTable />
    </div>
  );
};

const StoreJoinRequestPage = () => {
  return (
    // ContextProvider
    <StoreJoinRequestContextProvider>
      <PrizeContextProvider>
        <Store />
      </PrizeContextProvider>
    </StoreJoinRequestContextProvider>
  );
};
export default StoreJoinRequestPage;
